<template>
  <div>
    <template v-if="!isEdit">
      <v-layout class="text-xs-left">
        <v-flex class="form-control pa-2">
          {{ name }}
          <span class="info--text">{{
            flowtemplate != null ? `(Template ${flowtemplate})` : ''
          }}</span>
          <v-icon color="green" small v-if="flow.ispublic">public</v-icon>
          <div class="caption grey--text">{{ flow.description }}</div>
        </v-flex>
        <v-flex
          v-if="
            $store.state.superadmin.includes($store.state.userid) ||
              (flow.id &&
                (flow.owneradminid == $store.state.userid || flow.createdby == $store.state.userid))
          "
          shrink
          class="text-xs-right"
          style="white-space: nowrap;"
        >
          <v-btn class="my-0" fab small color="primary" depressed @click="onEdit">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn class="my-0" fab small color="primary" depressed @click="$emit('onDelete')">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-else>
      <v-layout class="text-xs-left">
        <v-flex class="pa-1">
          <div class="form-control" :class="{ 'has-error': errors.has('flow_name') }">
            <input
              type="text"
              class="mb-0"
              placeholder="Flow name"
              data-vv-as="Flow name"
              name="flow_name"
              v-validate="`required`"
              v-model="name"
            />
            <span class="text-error">{{ errors.first('flow_name') }}</span>
          </div>
        </v-flex>
        <v-flex class="pa-1" >
          <div class="form-control" :class="{ 'has-error': errors.has('flow_template') }">
            <input
              type="text"
              class="mb-0"
              placeholder="Flow Template"
              data-vv-as="Flow Template"
              name="flow_template"
              v-model="flowtemplate"
            />
            <span class="text-error">{{ errors.first('flow_template') }}</span>
          </div>
        </v-flex>
        <v-checkbox label="Share flow" v-model="isPublic" value="true"></v-checkbox>
        <v-btn fab small color="primary" depressed @click="onSave">
          <v-icon>check</v-icon>
        </v-btn>
        <v-btn fab small color="primary" depressed @click="onCancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-layout>
      <div
        class="form-control pa-1"
        v-if="
          $store.state.superadmin.includes($store.state.userid) ||
            (flow.id && flow.owneradminid == $store.state.userid) ||
            !flow.id
        "
      >
        <textarea
          label="Description"
          name="description"
          placeholder="Description"
          data-vv-as="Description"
          textarea
          v-model="flow.description"
          outline
        />
      </div>
      <div v-else class="pa-1 grey--text">
        {{ flow.description }}
      </div>
      <!-- <div class="form-control" :class="{ 'has-error': errors.has('pageidlist') }">
        <page-list v-model="flow.pageidlist" v-if="$store.state.userid == 'admin'"></page-list>
        <input type="hidden" name="pageidlist" v-model="flow.pageidlist" data-vv-as="Page list" />
        <span class="red--text caption">{{ errors.first('pageidlist') }}</span>
      </div> -->
    </template>
  </div>
</template>

<script>
import PageList from './PageList'
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      flow: {
        flowname: '',
        pageidlist: '',
        template: '',
        description: '',
        ispublic: false
      },
      name: null,
      flowtemplate: null,
      isPublic: false,
      isEdit: false
    }
  },
  components: {
    PageList
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    if (this.value) {
      this.flow = this.value
    } else {
      this.isEdit = true
    }
    this.name = this.flow.flowname
    this.isPublic = this.flow.ispublic ? 'true' : null
    this.flowtemplate = this.flow.template
    this.cached_flow = JSON.stringify(this.flow)
    // this.$set(this.flow, 'pageidlist', this.flow.pageidlist || this.selectedBot.pageid)
  },
  methods: {
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }

        var data = {
          ...vm.flow,
          flowname: vm.name,
          template: vm.flowtemplate,
          description: vm.flow.description || '',
          ispublic: vm.isPublic == 'true' || false
        }
        if (vm.flow.id) {
          data.id = vm.flow.id
          data.x = vm.flow.x
          data.y = vm.flow.y
          data.zoom = vm.flow.zoom
          data.adminid = vm.flow.owneradminid
        }
        vm.$emit('onSave', data)
        vm.flow = data
        vm.cached_flow = JSON.stringify(data)
        vm.isEdit = false
      })
    },
    onCancel() {
      this.isEdit = false
      this.$emit('onCancel')
      this.flow = JSON.parse(this.cached_flow)
      this.name = this.flow.flowname
      this.flowtemplate = this.flow.template
    },
    onEdit() {
      this.isEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/AddFlow.vue